import React from "react";
import { cn } from "@/lib/utils";
import { AppStripItemConfig } from "./appStripTypes";
import { useAppStripItems } from "./useAppStripItems";

/**
 * Phone replacement for the app strip. The rail is hidden under 768px so the
 * page gets the full width; this grid at the top of the menu sheet is where a
 * member switches apps instead.
 */
export default function MobileAppGrid() {
  const { activeApp, visibleItems, openApp } = useAppStripItems();

  const handleClick = (item: AppStripItemConfig) => {
    if (item.isExternal && item.externalUrl) {
      const separator = item.externalUrl.includes("?") ? "&" : "?";
      window.open(
        `${item.externalUrl}${separator}forceReauth=true`,
        "_blank",
        "noopener,noreferrer",
      );
      return;
    }
    openApp(item);
  };

  return (
    <nav aria-label="Apps" className="px-2 pb-2 pt-3" data-testid="mobile-apps">
      <p className="mb-2 px-1 text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground">
        Apps
      </p>
      <div className="grid grid-cols-4 gap-1">
        {visibleItems.map((item) => {
          const Icon = item.icon;
          const isActive = !item.isExternal && activeApp === item.id;
          return (
            <button
              aria-current={isActive ? "page" : undefined}
              aria-label={item.name}
              className={cn(
                "flex min-h-[56px] flex-col items-center justify-center gap-1 rounded-lg px-1 py-1.5 text-[10px] font-medium leading-tight transition-colors",
                isActive
                  ? "bg-sidebar-accent text-sidebar-accent-foreground"
                  : "text-muted-foreground hover:bg-sidebar-accent/50 hover:text-sidebar-foreground",
              )}
              key={item.id}
              onClick={() => handleClick(item)}
              type="button"
            >
              <Icon className="h-5 w-5" />
              <span className="w-full truncate text-center">
                {item.shortLabel ?? item.name}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
